import PropTypes from 'prop-types'
import { useState, useEffect, useCallback, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { LoginContext } from '../context/loginContext'
import * as domiciliosService from '../servicios/domiciliosService'
import * as fetchProvinciasAPI from '../servicios/fetchProvinciasAPI'
import FormInsertDomicilio from './FormInsertDomicilio'
import Formulario from './Formulario'

const Domicilios = (props) => {
  const [domicilios, setDomicilios] = useState([])
  const [showFormAgregar, setShowFormAgregar] = useState(false)
  const [domicilioPrincipalInsert, setDomicilioPrincipalInsert] = useState(false)
  const [domicilioFacturacionInsert, setDomicilioFacturacionInsert] = useState(false)
  const [provinciasAPI, setProvinciasAPI] = useState([])
  const location = useLocation()
  const { loginDataContext } = useContext(LoginContext)

  const { nuevo, domicilio } = location.state || {}
  const tipoUsuario = loginDataContext.tipoUsuario

  const searchMethod = useCallback(async () => {
    const { data: domicilios } = await domiciliosService.buscarTodas(
      parseInt(localStorage.getItem('idUsuario')),
      tipoUsuario
    )
    setDomicilios(domicilios)

    const { data: provinciasAPI } = await fetchProvinciasAPI.buscarProvinciasEnEBM()
    setProvinciasAPI(provinciasAPI)
  }, [tipoUsuario])

  useEffect(() => {
    searchMethod()
  }, [searchMethod])

  useEffect(() => {
    if (props.buscar) {
      searchMethod()
    }
  }, [props.buscar, searchMethod])

  useEffect(() => {
    if (nuevo === '1') {
      setShowFormAgregar(true)
    } else if (domicilio) {
      setShowFormAgregar(false)
      setDomicilios((prev) =>
        prev.map((d) => ({
          ...d,
          showForm: d.idUsuarioDomicilio.toString() === domicilio
        }))
      )
    }
  }, [nuevo, domicilio])

  const handleDelete = async (idUsuarioDomicilio) => {
    try {
      await domiciliosService.eliminarDomicilio(idUsuarioDomicilio)
      const filtrado = domicilios.filter(
        (domicilio) => domicilio.idUsuarioDomicilio !== idUsuarioDomicilio
      )
      setDomicilios(filtrado)
    } catch (error) {
      const mensaje = `Ocurrió un error al eliminar el domicilio.`
      toastErrorLog(error, mensaje, 'domicilio')
    }
  }

  const handleSave = async (idUsuarioDomicilio, domicilio) => {
    try {
      await domiciliosService.actualizarDomicilio(domicilio)
      const domiciliosClon = [...domicilios]
      const indicePorActualizar = domiciliosClon.findIndex(
        (d) => d.idUsuarioDomicilio === idUsuarioDomicilio
      )
      domiciliosClon[indicePorActualizar] = domicilio
      setDomicilios(domiciliosClon)
      toggleFormHandler(0)
    } catch (error) {
      const mensaje = `Ocurrió un error al guardar el domicilio.`
      toastErrorLog(error, mensaje, 'domicilio')
    }
  }

  const handleNewDomicilio = async (domicilio) => {
    try {
      const { data: domicilioInsertado } = await domiciliosService.insertar(domicilio)
      setDomicilios((prev) => [...prev, domicilioInsertado])
      setShowFormAgregar(!showFormAgregar)
    } catch (error) {
      const mensaje = `Ocurrió un error al guardar el domicilio.`
      toastErrorLog(error, mensaje, 'domicilio')
    }
  }

  const handleChangeDomicilio = (e, idUsuarioDomicilio) => {
    const { checked, name } = e.target

    if (name === 'domicilioPrincipal' && checked) {
      setDomicilios((prevDomicilios) =>
        prevDomicilios.map((domicilio) =>
          domicilio.idUsuarioDomicilio === idUsuarioDomicilio
            ? { ...domicilio, domicilioPrincipal: checked }
            : { ...domicilio, domicilioPrincipal: false }
        )
      )

      if (idUsuarioDomicilio === 0) {
        setDomicilioPrincipalInsert(checked)
      }
    }

    if (name === 'domicilioFacturacion' && checked) {
      setDomicilios((prevDomicilios) =>
        prevDomicilios.map((domicilio) =>
          domicilio.idUsuarioDomicilio === idUsuarioDomicilio
            ? { ...domicilio, domicilioFacturacion: checked }
            : { ...domicilio, domicilioFacturacion: false }
        )
      )

      if (idUsuarioDomicilio === 0) {
        setDomicilioFacturacionInsert(checked)
      }
    }
  }

  const toggleFormHandler = (idUsuarioDomicilio) => {
    setDomicilios((prevDomicilios) =>
      prevDomicilios.map((domicilio) =>
        domicilio.idUsuarioDomicilio === idUsuarioDomicilio
          ? { ...domicilio, showForm: !domicilio.showForm }
          : { ...domicilio, showForm: false }
      )
    )
  }

  return (
    <div className="row mt-4">
      <div className="col-12 col-lg">
        <h3>Domicilios</h3>
        {showFormAgregar ? (
          <div>
            <FormInsertDomicilio
              onNew={handleNewDomicilio}
              onChangeDomicilio={handleChangeDomicilio}
              domicilioPrincipal={domicilioPrincipalInsert}
              domicilioFacturacion={domicilioFacturacionInsert}
              provinciasAPI={provinciasAPI}
              onSave={handleSave}
            />
          </div>
        ) : (
          <div className="contenedor-datos-perfil ml-2">
            {domicilios.map((domicilio, index) => (
              <div key={index}>
                <Formulario
                  domicilio={domicilio}
                  onDelete={handleDelete}
                  onSave={handleSave}
                  onChangeDomicilio={handleChangeDomicilio}
                  onToggleFormHandler={toggleFormHandler}
                  showForm={domicilio.showForm}
                  provinciasAPI={provinciasAPI}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

Domicilios.propTypes = {
  buscar: PropTypes.bool
}

export default Domicilios
